import { useEffect, useRef, useState } from "react";
import EditableText from "../common/EditableText";
import { useDispatch, useSelector } from "react-redux";
import {
  editDashboardItemByItem,
  getCurrentDashboardMode,
} from "src/store/dashboardSlice";
import GitCommitText from "../common/GitCommitText";
import OverflowAware from "../common/OverflowAware";
import { naruhoneStyles } from "src/styles/naruhoneStyles";

const TitleWidget = ({ item, containerRef }) => {
  const dashboardMode = useSelector(getCurrentDashboardMode);
  const naruhoneData = useSelector((state) => state.dashboard.naruhone);
  const [didMakeEdit, setDidMakeEdit] = useState(false);
  const [itemTitle, setItemTitle] = useState(item?.itemData ?? "");
  const dispatch = useDispatch();

  const titleStyle =
    "mb-4 text-center text-4xl font-bold text-white md:text-4xl lg:text-5xl";
  const overflowRef = useRef();

  useEffect(() => {
    if (naruhoneData) {
      overflowRef.current?.manualCheck();
    }
  }, [naruhoneData]);

  return (
    <OverflowAware
      containerRef={containerRef}
      ref={overflowRef}
      className="flex flex-col h-full justify-center p-4"
      original={
        <div>
          <EditableText
            text={itemTitle}
            onChange={(newHeading) => {
              setItemTitle(newHeading);
              if (newHeading !== itemTitle) {
                setDidMakeEdit(true);
                let itemEdit = { ...item, itemData: newHeading };
                dispatch(editDashboardItemByItem(itemEdit));
              }
            }}
            className={`${naruhoneStyles.h1Text} text-5xl text-center mb-4`}
            placeholder="Enter a title"
            isEditable={dashboardMode === "edit"}
          />
          <GitCommitText />
        </div>
      }
      fallback={
        <div className="flex align-center justify-center">
        <EditableText
          text={itemTitle}
          onChange={(newHeading) => {
            setItemTitle(newHeading);
            if (newHeading !== itemTitle) {
              setDidMakeEdit(true);
              let itemEdit = { ...item, itemData: newHeading };
              dispatch(editDashboardItemByItem(itemEdit));
            }
          }}
          className={`${naruhoneStyles.h1Text} text-5xl align-center text-center mb-4`}
          placeholder="Enter a title"
          isEditable={dashboardMode === "edit"}
        />
        </div>
      }
      direction="vertical"
    />
  );
};
export default TitleWidget;
